import type {
  CargoType,
  CargoTypeApi,
  CargoTypeFilters,
  CargoTypeFiltersUpdateApi,
  CargoTypes,
  CargoTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

// Cargo Type pricing flag stored in `string1` (API returns it as "Pricing").
const PRICING_CARGO_FLAG = 'PRICING';

export const normalizeCargoType = (cargoType: CargoTypeApi): CargoType => ({
  ...cargoType,
  id: cargoType.codeId ?? String(cargoType.id),
  label: cargoType.codeDesc,
});

export const normalizeCargoTypes = (response: CargoTypesApi): CargoTypes => {
  const list = (response.items ?? [])
    .filter((cargoType) => cargoType.string1?.toUpperCase() === PRICING_CARGO_FLAG)
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeCargoType);
  return {
    list,
    map: list.reduce(
      (acc, cargoType) => {
        acc[String(cargoType.id)] = cargoType;
        return acc;
      },
      {} as CargoTypes['map'],
    ),
  };
};

export const normalizeCargoTypeFilters = (filters: Partial<CargoTypeFilters>): CargoTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
